const API_BASE_URL = process.env.REACT_APP_BASE_API
    || (process.env.NODE_ENV === 'production'
        ? 'https://www.heartyconsulting.com/crmservice'
        : 'http://localhost:8080/crmservice');

export const buildApiUrl = (path: string): string => {
    if (!path) {
        return API_BASE_URL;
    }
    if (/^https?:\/\//i.test(path)) {
        return path;
    }
    return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

const getBackendOrigin = () => {
    try {
        return new URL(API_BASE_URL, window.location.origin).origin;
    } catch (e) {
        return window.location.origin;
    }
};

export const buildFileUrl = (fileUrl?: string | null): string => {
    if (!fileUrl) {
        return '';
    }
    const raw = String(fileUrl).trim();
    if (!raw) {
        return '';
    }
    if (/^https?:\/\//i.test(raw)) {
        return raw;
    }
    if (raw.startsWith('//')) {
        return `${window.location.protocol}${raw}`;
    }
    const backendOrigin = getBackendOrigin();
    if (raw.startsWith('/')) {
        return `${backendOrigin}${raw}`;
    }
    return `${backendOrigin}/${raw}`;
};

export const triggerDownload = (url: string, fileName?: string) => {
    if (!url) {
        return;
    }
    const link = document.createElement('a');
    link.href = url;
    if (fileName) {
        link.download = fileName;
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
